if (!customElements.get('collection-hover-showcase')) {
  class CollectionHoverShowcase extends HTMLElement {
    constructor() {
      super();

      this.list = this.querySelector('.collection-showcase__list');
      this.items = this.querySelectorAll('.collection-showcase__item');
      this.imageLinks = this.querySelectorAll('.collection-showcase__image-link');

      if (!this.list || this.items.length === 0 || this.imageLinks.length === 0) return;

      this.currentIndex = 0;
      this.init();
    }

    init() {
      this.setupHoverEvents();
      this.setActive(0);
    }

    setupHoverEvents() {
      this.items.forEach((item, index) => {
        const link = item.querySelector('.collection-showcase__link');

        const activate = () => {
          this.setActive(index);
        };

        item.addEventListener('mouseenter', activate);
        if (link) {
          link.addEventListener('focus', activate);
        }
      });

      this.list.addEventListener('mouseenter', () => {
        this.list.classList.add('has-hover');
      });

      this.list.addEventListener('mouseleave', () => {
        this.list.classList.remove('has-hover');
      });
    }

    setActive(index) {
      if (index < 0 || index >= this.items.length) return;
      this.currentIndex = index;

      this.items.forEach((item, i) => {
        if (i === index) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });

      this.imageLinks.forEach((imgLink, i) => {
        if (i === index) {
          imgLink.classList.add('is-active');
        } else {
          imgLink.classList.remove('is-active');
        }
      });
    }
  }

  customElements.define('collection-hover-showcase', CollectionHoverShowcase);
}
